module.exports = __webpack_public_path__ + "static/media/MR.bd1bb5dd.svg";